/**
 * Country → theme mapping for destination-themed loading animations.
 * Each entry defines the particle type, colors, and emoji used during itinerary generation.
 */

const DESTINATION_THEMES = {
  japan: {
    emoji: '🌸',
    particleType: 'cherry-blossoms',
    colors: ['#FFB7C5', '#FF69B4'],
    particleEmojis: ['🌸', '🎌', '⛩️', '🏯'],
  },
  india: {
    emoji: '🪔',
    particleType: 'lanterns',
    colors: ['#FF9933', '#FFD700'],
    particleEmojis: ['🪔', '🕌', '🐘', '✨'],
  },
  iceland: {
    emoji: '❄️',
    particleType: 'snowflakes',
    colors: ['#A8D8EA', '#88C8E8'],
    particleEmojis: ['❄️', '🏔️', '🌊', '✨'],
  },
  france: {
    emoji: '🗼',
    particleType: 'stars',
    colors: ['#002395', '#ED2939'],
    particleEmojis: ['🗼', '🥐', '🍷', '✨'],
  },
  italy: {
    emoji: '🍕',
    particleType: 'stars',
    colors: ['#008C45', '#CD212A'],
    particleEmojis: ['🍕', '🏛️', '🍝', '✨'],
  },
  spain: {
    emoji: '💃',
    particleType: 'stars',
    colors: ['#C60B1E', '#FFC400'],
    particleEmojis: ['💃', '🌻', '🏰', '✨'],
  },
  thailand: {
    emoji: '🛕',
    particleType: 'lanterns',
    colors: ['#FFD700', '#FF6347'],
    particleEmojis: ['🛕', '🐘', '🌺', '✨'],
  },
  mexico: {
    emoji: '🌮',
    particleType: 'stars',
    colors: ['#006847', '#CE1126'],
    particleEmojis: ['🌮', '🎸', '🌵', '✨'],
  },
  egypt: {
    emoji: '🏛️',
    particleType: 'stars',
    colors: ['#C8A951', '#D4A843'],
    particleEmojis: ['🏛️', '🐫', '🌅', '✨'],
  },
  brazil: {
    emoji: '🎉',
    particleType: 'stars',
    colors: ['#009739', '#FEDD00'],
    particleEmojis: ['🎉', '🦜', '⚽', '✨'],
  },
  morocco: {
    emoji: '🕌',
    particleType: 'lanterns',
    colors: ['#C1272D', '#E8A54B'],
    particleEmojis: ['🕌', '🐪', '🏜️', '✨'],
  },
  australia: {
    emoji: '🦘',
    particleType: 'leaves',
    colors: ['#00843D', '#FFCD00'],
    particleEmojis: ['🦘', '🏖️', '🌿', '✨'],
  },
  'south korea': {
    emoji: '🏯',
    particleType: 'cherry-blossoms',
    colors: ['#CD2E3A', '#0047A0'],
    particleEmojis: ['🌸', '🏯', '🎎', '✨'],
  },
  turkey: {
    emoji: '🕌',
    particleType: 'lanterns',
    colors: ['#E30A17', '#FFD700'],
    particleEmojis: ['🕌', '🎈', '☕', '✨'],
  },
  greece: {
    emoji: '🏛️',
    particleType: 'stars',
    colors: ['#0D5EAF', '#FFFFFF'],
    particleEmojis: ['🏛️', '⛵', '🫒', '✨'],
  },
  peru: {
    emoji: '🏔️',
    particleType: 'stars',
    colors: ['#D91023', '#FFD700'],
    particleEmojis: ['🏔️', '🦙', '🌄', '✨'],
  },
  'new zealand': {
    emoji: '🌿',
    particleType: 'leaves',
    colors: ['#00843D', '#1E90FF'],
    particleEmojis: ['🌿', '🐑', '🏔️', '✨'],
  },
  canada: {
    emoji: '🍁',
    particleType: 'leaves',
    colors: ['#FF0000', '#FF6B35'],
    particleEmojis: ['🍁', '🏔️', '🦌', '✨'],
  },
  nepal: {
    emoji: '🏔️',
    particleType: 'snowflakes',
    colors: ['#DC143C', '#003893'],
    particleEmojis: ['🏔️', '🕉️', '🙏', '✨'],
  },
  indonesia: {
    emoji: '🌴',
    particleType: 'leaves',
    colors: ['#FF0000', '#00A86B'],
    particleEmojis: ['🌴', '🐒', '🏝️', '✨'],
  },
};

const DEFAULT_THEME = {
  emoji: '✨',
  particleType: 'stars',
  colors: ['#4285F4', '#1A73E8'],
  particleEmojis: ['✨', '🌍', '✈️', '⭐'],
};

/**
 * Look up a destination theme by country name.
 * Returns DEFAULT_THEME for unknown countries.
 */
export const getDestinationTheme = (country) => {
  if (!country) return DEFAULT_THEME;
  const key = country.toLowerCase().trim();
  return DESTINATION_THEMES[key] || DEFAULT_THEME;
};

export { DEFAULT_THEME };
export default DESTINATION_THEMES;
